import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import managerAPI from "../../../apis/manager/managerAPI";

function SavedFiles({ hideModal, isOpen }) {
    const [files, setFiles] = useState([]);

    async function getSavedFiles() {
        try {
            const res = await managerAPI.getSavedReports();
            setFiles(res);
        } catch (error) {
            console.log(error);
       }
    }

    useEffect(() => {
        let flag = true;
        if (flag) {
            getSavedFiles();
        }
        return () => {
            flag = false;
        };
    }, []);

    return (
    <Modal show={isOpen} onHide={() => hideModal()} top size='md'>
      <Modal.Header className="pb-2" closeButton>
        <Modal.Title>
          <h2>Requested Reports</h2>
        </Modal.Title>
      </Modal.Header>
          <Modal.Body className="mb-4">
              <ul>
                  {files?.map((file, index) => (
                      <li key={file.id} className="d-flex align-items-center justify-content-between mb-4">
                          <div className="d-flex align-items-center">
                              <div>
                                  <h5 className="mb-0">{file.fileName}</h5>
                                  <p className="mb-0">{}</p>
                              </div>
                          </div>
                          <div>
                              <button onClick={() => window.location.assign(file.fileUrl)} className="btn btn-secondary btn-sm ms-3">Download</button>
                          </div>
                      </li>
                  ))}
                  {files?.length === 0 && (
                      <div className="text-center">
                          <p>No reports found.</p>
                      </div>
                  )}

              </ul>
          </Modal.Body>
      </Modal>
      
  )
}

export default SavedFiles